'use client'

import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import { PropsWithChildren, useEffect } from 'react';
import ButtonClose from '../Form/ButtonClose';

interface DrawerProps {
    open: boolean;
    closeable?: boolean;
    onClose: CallableFunction;
    title?: string | null;
    subtitle?: any | null;
    fromBottom?: boolean;
    fromLeft?: boolean;
    backdrop?: boolean;
    className?: string | null;
    classNameChildren?: string | null;
    classNameCloseButton?: string | null;
}

const Drawer = ({
    children,
    open = false,
    closeable = true,
    onClose = () => {},
    title = null,
    subtitle = null,
    fromBottom = false,
    fromLeft = false,
    backdrop = true,
    className = '',
    classNameChildren = '',
    classNameCloseButton = ''
}: PropsWithChildren<DrawerProps>) => {

  const close = () => {
    if (closeable) {
      onClose();
    }
  };

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      event.preventDefault();
      onClose();
    };
    window.addEventListener('popstate', handlePopState);
    window.history.pushState({}, '');
    return () => {
      window.removeEventListener('popstate', handlePopState);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog open={open} onClose={close} className="relative z-30">

      {backdrop &&
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-800/60 backdrop-blur-sm transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
        />
      }

      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className={`
            pointer-events-none fixed inset-y-0 flex max-w-full
            ${fromLeft ? 'md:pr-20 left-0' : 'md:pl-20 right-0'}
          `}>
            <DialogPanel
              transition
              className={`
                pointer-events-auto w-screen max-w-full md:max-w-md transform transition duration-200 ease-in-out
                ${fromBottom ? 'data-[closed]:translate-y-full' : fromLeft ? 'data-[closed]:-translate-x-full' : 'data-[closed]:translate-x-full'}
                ${className}
              `}
            >
              {closeable && <ButtonClose fixedOnTop onClick={close} className={`z-90 ${classNameCloseButton}`} />}

              <div className="flex h-full flex-col overflow-y-auto bg-white shadow-xl">
                {title &&
                  <div className="p-4 ring-1 ring-gray-100">
                    <div className="flex items-center justify-between gap-2 mr-8">

                      <div className='grid gap-2'>
                        <div className="text-xl font-extrabold text-shopfood-title leading-5">{title}</div>
                        {subtitle && <div className="text-sm text-gray-500">{subtitle}</div>}
                      </div>

                    </div>
                  </div>
                }
                <div className={`relative flex-1 ${title ? 'pt-2' : ''} ${classNameChildren}`}>{children}</div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default Drawer;